import {sliderMini} from './sliderMini'
import './sliderMini.sass'
import {forEach} from "../../js/helpers";

forEach(document.querySelectorAll(".sliderMini"), item => sliderMini(item));
